import { AuthTypes } from 'enums';
import {
    streamHasAuthType,
    isUserAuthenticated
} from 'lib/auth';
export default function getFirstStreamUserAuth(streams, userAuth) {
    for (let stream of streams) {
        const isTVEAuthenticated = isUserAuthenticated(userAuth, AuthTypes.MVPD) || isUserAuthenticated(userAuth, AuthTypes.ISP);
        const isBAMAuthenticated = isUserAuthenticated(userAuth, AuthTypes.BAM);
        const isBAMStream = streamHasAuthType(stream, AuthTypes.BAM);
        const isTVEStream = streamHasAuthType(stream, AuthTypes.MVPD) || streamHasAuthType(stream, AuthTypes.ISP);
        
        if ((isTVEAuthenticated && isTVEStream) || (isBAMAuthenticated && isBAMStream )) {
            return stream;
        }
    }
    return null;
}


// WEBPACK FOOTER //
// ./app/lib/auth/getFirstStreamUserAuth.js